import { render, staticRenderFns } from "./ReviewUserActions.vue?vue&type=template&id=5397eff7&scoped=true&"
import script from "./ReviewUserActions.vue?vue&type=script&lang=js&"
export * from "./ReviewUserActions.vue?vue&type=script&lang=js&"
import style0 from "./ReviewUserActions.vue?vue&type=style&index=0&id=5397eff7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5397eff7",
  null
  
)

export default component.exports